import React from "react";
// import Progress from "../Progress";
import "../ContentPages/style.css";
import SubmitButton from "../Buttons/SubmitButton";
import loginEnvMap from "../../config.js";

export const Inactive = () => {
  return (
    <>
      <div className="intro">
        {/* <Progress progress={0} /> */}
        <h1 className="intro-title-mi" lang="mi-NZ">
          Kua takiputa koe
        </h1>
        <hr />
        <h1 className="intro-title">You've been logged out</h1>

        <div className="step-container">
          <p className="mb-4">
            You've been inactive for 10 minutes and have been logged out for
            your security.
          </p>
          <p className="mb-4">
            The completed sections of your application have been saved, but you
            need to restart any incomplete sections.
          </p>
          <p className="mb-4">Log in again to continue your application.</p>
        </div>
        <div className="step-button-container">
          <SubmitButton
            text={"Login"}
            onClick={() => {
              const env = (window.env || "").toLowerCase();
              const apiUrl = process.env.REACT_APP_API_URL;
              const loginUrl = apiUrl
                ? `${apiUrl}/saml/login`
                : "/api/saml/login";
              window.location.href = loginEnvMap[env] || loginUrl;
            }}
          />
        </div>
      </div>
    </>
  );
};

export default Inactive;
